import React, {Component, Fragment, ReactNode} from 'react';
import {scrollByHash} from 'app/utils';
import {i18n_t} from 'app/i18n';
import {inject, observer} from 'mobx-react';
import NotificationSetting from 'app/components/my_profile/NotificationSetting';
import {notificationSettingsStore} from 'app/store/global';
import {toastError, toastSuccess} from 'app/components/toasts/liteToast';
import NotificationsSettingsStoreInterface from 'app/interfaces/stores/NotificationsSettingsStoreInterface';

@inject('notificationSettingsStore')
@observer
export default class MenuAlertPoint extends Component<NotificationsSettingsStoreInterface> {
    state = {
        submit_disabled: true
    };

    componentDidMount(): void {
        scrollByHash();
    }

    handleChangeSettings = (value: boolean, stateName: string): void => {
        this.props.notificationSettingsStore.update({
            [stateName]: value
        });
        this.setState({submit_disabled: false});
    };

    saveSettings = (): void => {
        const settings = this.props.notificationSettingsStore.notificationSettings;
        notificationSettingsStore.saveSettings(settings).then((success: boolean | void) => {
            if (success) {
                toastSuccess(i18n_t('settings_successfully'));
                this.setState({submit_disabled: true});
            } else {
                toastError(i18n_t('server_error_try_later'));
            }
        });
    };

    handleSaveClick = (): void => {
        if (!this.state.submit_disabled) {
            this.saveSettings();
        }
    };

    render(): ReactNode {
        const notificationSettings = this.props.notificationSettingsStore.notificationSettings;
        const notification_names = Object.keys(notificationSettings);

        return <Fragment>
            <div className="settings__notifications">
                <h1 className="title">{i18n_t('notification_settings.title')}</h1>
                <form className="form form-settings form-settings__notifications">
                    <div className="form__item-list">
                        {notification_names.map((name: string, i: number) => <NotificationSetting
                            handleChangeSettings={this.handleChangeSettings}
                            id={i}
                            key={i}
                            name={name}
                            status={notificationSettings[name]}
                        />)}
                    </div>

                    <div className="form__row form__row__actions">
                        <label
                            id="save_settings_button"
                            className={
                                `button btn form__submit-btn ${this.state.submit_disabled ? 'btn--disable' : ''}`
                            }
                            onClick={this.handleSaveClick}
                        >
                            {i18n_t('save')}
                        </label>
                    </div>
                </form>
            </div>
        </Fragment>;
    }
}
